import React from "react";
import NavBar from "./NavBar";

const Loading = ({ currentPage, progress = 0, message = "Loading..." }) => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {!(currentPage === "/login" || currentPage === "/") && (
        <NavBar currentPage={currentPage} />
      )}
      <div className="flex-grow flex flex-col items-center justify-center">
        <div className="flex flex-col items-center">
          {/* Progress circle */}
          <div className="relative w-20 h-20">
            {/* Background circle */}
            <svg
              className="w-20 h-20 transform -rotate-90"
              viewBox="0 0 100 100"
            >
              <circle
                cx="50"
                cy="50"
                r="40"
                stroke="currentColor"
                strokeWidth="8"
                fill="transparent"
                className="text-gray-200"
              />
              {/* Progress circle */}
              <circle
                cx="50"
                cy="50"
                r="40"
                stroke="currentColor"
                strokeWidth="8"
                fill="transparent"
                strokeDasharray={`${2 * Math.PI * 40}`}
                strokeDashoffset={`${2 * Math.PI * 40 * (1 - progress / 100)}`}
                className="text-gray-700 transition-all duration-500 ease-out"
                strokeLinecap="round"
              />
            </svg>
            {/* Progress percentage */}
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-sm font-semibold text-gray-700">
                {Math.round(progress)}%
              </span>
            </div>
          </div>
          <p className="mt-4 text-lg font-medium text-gray-700">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default Loading;
